export const sectionToolbarAddMenuTestIds = {
  addIcon: 'section-add-icon',
};
